// import { fieldsetDateFilter } from '@global/filters/fieldset-date.filter'
import moment from 'moment'
import * as dateFormaters from 'handsontable/utils/convertDateUtil'

export const PreviewValueGenerators = {
  autonumber,
  constant,
  date,
  random,
  variable,
  unknown,
}

function fieldsetDateFilter(rawDate = 0, fieldsetField = { date: {} }) {
  rawDate = moment(rawDate)
  const formatString = dateFormaters.convertDateFieldToMomentJsFormat(fieldsetField)
  return rawDate.format(formatString)
}

function unknown(element) {
  return element.segment_type.toUpperCase()
}

function autonumber(element) {
  const start = element.autonumber ? element.autonumber.start_value : 1
  const width = element.autonumber ? element.autonumber.min_width : 1
  return padStart(`${start}`, width, '0')
}

function constant(element) {
  const value = element.constant_value ? element.constant_value : element.segment_type.toUpperCase()
  return value
}

function date(element) {
  // for now, also preview with the current date
  return fieldsetDateFilter(new Date(), element)
}

function random(element) {
  const maxLength = element.max_length
  const includeNumeric = element.random.include_numeric
  const includeUppercase = element.random.include_uppercase
  const includeLowercase = element.random.include_lowercase

  // cache the preview.  Not ideal to modify the element, but works for now
  if (!element._preview) {
    const preview = randomString(maxLength, includeUppercase, includeLowercase, includeNumeric)
    element._preview = preview
  }

  return element._preview
}

function variable(element) {
  const name = element.name || 'VARIABLE'
  return `[${name}]`
}

function randomString(length, useUpper, useLower, useDigits) {
  let charset = ''
  let result = ''
  charset += useUpper ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' : ''
  charset += useLower ? 'abcdefghijklmnopqrstuvwxyz' : ''
  charset += useDigits ? '0123456789' : ''

  // grab a char at random from the charset and append it
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length))
  }

  return result
}

function padStart(toPad, targetLength, padString) {
  targetLength >>= 0 // truncate if number or convert non-number to 0;
  padString = String(typeof padString !== 'undefined' ? padString : ' ')
  if (toPad.length > targetLength) {
    return String(toPad)
  }
  targetLength -= toPad.length
  if (targetLength > padString.length) {
    padString += padString.repeat(targetLength / padString.length) // append to original to ensure we are longer than needed
  }
  return padString.slice(0, targetLength) + String(toPad)
}
